var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBronze(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 42C32.598 42 42 32.598 42 21C42 9.40202 32.598 0 21 0C9.40202 0 0 9.40202 0 21C0 32.598 9.40202 42 21 42Z",
    fill: "#CBA975"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 5C29.8366 5 37 12.1634 37 21C37 29.8366 29.8366 37 21 37C12.1634 37 5 29.8366 5 21C5 12.1634 12.1634 5 21 5ZM16.3778 14.4815H14.9556C14.3665 14.4815 13.8889 14.959 13.8889 15.5481V26.4519C13.8889 27.041 14.3665 27.5185 14.9556 27.5185H16.3778C16.9669 27.5185 17.4444 27.041 17.4444 26.4519V15.5481C17.4444 14.959 16.9669 14.4815 16.3778 14.4815ZM21.7111 14.4815H20.2889C19.6998 14.4815 19.2222 14.959 19.2222 15.5481V26.4519C19.2222 27.041 19.6998 27.5185 20.2889 27.5185H21.7111C22.3002 27.5185 22.7778 27.041 22.7778 26.4519V15.5481C22.7778 14.959 22.3002 14.4815 21.7111 14.4815ZM27.0444 14.4815H25.6222C25.0331 14.4815 24.5556 14.959 24.5556 15.5481V26.4519C24.5556 27.041 25.0331 27.5185 25.6222 27.5185H27.0444C27.6335 27.5185 28.1111 27.041 28.1111 26.4519V15.5481C28.1111 14.959 27.6335 14.4815 27.0444 14.4815Z",
    fill: "#F5D9B0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBronze);
export default __webpack_public_path__ + "static/media/bronze.f3aaf8433db242ddd7d6c19c84c0ebbc.svg";
export { ForwardRef as ReactComponent };